import { stringArrayToObject } from '../../utils/array';

import { loadCollections } from '../../services/DatabaseService';

/* ------------- Country actions ------------- */
export const actions = stringArrayToObject(
  ['LOAD_START', 'LOAD_SUCCESS', 'LOAD_FAIL'],
  '@COLLECTIONS',
);

const privateActionCreators = {
  loadStart() {
    return {
      type: actions.LOAD_START,
    };
  },
  loadSuccess(list) {
    return {
      type: actions.LOAD_SUCCESS,
      payload: { list },
    };
  },
  loadFailure(err) {
    return {
      type: actions.LOAD_FAIL,
      payload: { err },
    };
  },
};

export const actionCreators = {
  load() {
    return async (dispatch) => {
      dispatch(privateActionCreators.loadStart());
      const response = await loadCollections();
      if (response.ok) {
        dispatch(privateActionCreators.loadSuccess(response.list));
      } else {
        dispatch(privateActionCreators.loadFailure(response.error));
      }
    };
  },
};



// WEBPACK FOOTER //
// ./src/redux/Collections/actions.js